/**
 * The TKC mark: three bars and the app's name.
 *
 * It lived inline in `AppShell` and was correct there. The dashboard banner
 * (punch 4.6) is the SECOND place that needs it, and two copies of a brand mark
 * is exactly the shape gate 15 exists for — `RouterAnchor` reached nine copies
 * and `Fact` thirteen before anybody noticed, and in both cases the copies had
 * already diverged. So it moves here on its first reuse rather than its third.
 *
 * NOT the logo. docs/04 §0's register lists the four-format TKC logo as
 * **Pending — blocked on name + assets** (O-16). This is the tri-bar treatment
 * from the approved prototype (docs/04 §6), which is what the app has today; if
 * real logo assets arrive, they replace the inside of this component and
 * nothing else. Matt, 2026-08-31, choosing it over waiting for O-16.
 *
 * The bars are `aria-hidden` and the name is real text, so a screen reader
 * hears "PropOS" once rather than three empty decorations and a word.
 */

import type { ReactNode } from 'react';

/** Bar heights per size — the only thing that changes between placements. */
const BAR = { sm: 'h-4', md: 'h-5' } as const;
const WORD = { sm: 'text-[17px]', md: 'text-[19px]' } as const;

export function BrandMark({ size = 'sm' }: { readonly size?: 'sm' | 'md' }): ReactNode {
  return (
    <span className="flex items-center gap-2">
      <span aria-hidden className="flex gap-0.5">
        <i className={`block w-1 rounded-xs bg-brick ${BAR[size]}`} />
        <i className={`block w-1 rounded-xs bg-gold ${BAR[size]}`} />
        <i className={`block w-1 rounded-xs bg-brand-600 ${BAR[size]}`} />
      </span>
      <span className={`font-display font-semibold text-on-green ${WORD[size]}`}>PropOS</span>
    </span>
  );
}
